module.exports = __webpack_public_path__ + "static/media/nodata.4c647700.png";